import '@/styles/index.css';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

import { ClerkProvider } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { pdfjs } from 'react-pdf';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/App';
import { getFallbackURL } from '@/lib/route';

// Use local worker file to avoid CORS issues
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const SENTRY_ENABLED =
  import.meta.env.PROD || import.meta.env.VITE_ENABLE_SENTRY === 'true';

if (SENTRY_DSN && SENTRY_ENABLED) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1,
  });
}

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Auth Publishable Key');
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <BrowserRouter>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      afterSignOutUrl={getFallbackURL()}
    >
      <App />
    </ClerkProvider>
  </BrowserRouter>
);
